import React, { useEffect, useRef, useState } from "react";
import { fetchHomecommunitylist } from "../services/Homecommunitylist";
import { API_BASE } from "../api/apiConfig";

const MoHomecommunitylist = () => {
  const [community, setcommunity] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchHomecommunitylist();
      if (res?.status && Array.isArray(res.data)) {
        setcommunity(res.data);
      }
    };
    loadData();
  }, []);


   /* ================= HELPERS ================= */
  const parseCategories = (category) => {
    if (!category) return [];
    try {
      const parsed = JSON.parse(category);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  /* ================= FILTER DATA ================= */

  const countries = [
    "All",
    ...new Set(community.map((m) => m.country).filter(Boolean)),
  ];

  const cities = [
    "All",
    ...new Set(
      community
        .filter(
          (m) => activeCountry === "All" || m.country === activeCountry
        )
        .map((m) => m.city)
        .filter(Boolean)
    ),
  ];

  const filteredcommunity = community.filter((m) => {
    if (activeCountry !== "All" && m.country !== activeCountry) return false;
    if (activeCity !== "All" && m.city !== activeCity) return false;
    return true;
  });

  /* ================= SLIDER SCROLL ================= */

  const scrollSlider = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "next" ? 350 : -350,
      behavior: "smooth",
    });
  };

  return (
    <section className="px-4 mb-10 pb-6 border-b border-slate-100">
        <div className="text-center mb-5">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-teal-50 border border-teal-200 mb-3">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users h-3.5 w-3.5 text-teal-600"
            >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx={9} cy={7} r={4} />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-xs font-medium text-teal-700">
                Active Communities
            </span>
            </div>
            <h3 className="text-xl font-bold text-slate-800 mb-2">
            Join Your <span className="text-teal-600">City Community</span>
            </h3>
            <p className="text-xs text-slate-600">
            Connect with travelers in your city
            </p>
        </div>
        <div className="flex gap-4 scrollbar-custom pb-2">
        
        {filteredcommunity.map((item, i) => (
            <a className="flex-shrink-0 w-56" href={`/CommunityDtl/${item.id}`}>
            <div className="rounded-lg bg-card text-card-foreground mobile-card border border-slate-200 shadow-md overflow-hidden hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="relative h-36 overflow-hidden">
                <img
                    alt={item.city}
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover"
                    style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: 0,
                    color: "transparent"
                    }}
                    src={
                          item.image
                            ? `${API_BASE}${item.image}`
                            : `${API_BASE}default.jpg`
                        }
                />
                <div className="absolute inset-0 bg-gradient-to-b from-blue-500/20 to-indigo-500/20" />
              {item?.tag && (
                <div className="absolute top-2 right-2 px-2 py-1 rounded-full bg-white/90 backdrop-blur-sm border border-white/20 shadow-sm">
                    <span className="text-xs font-semibold text-slate-700">
                    {item.tag}
                    </span>
                </div>
             )}
                </div>
                <div className="p-3">
                <div className="flex items-center gap-1.5 mb-3">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-4 w-4 text-teal-600"
                    >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx={12} cy={10} r={3} />
                    </svg>
                    <h4 className="text-base font-bold text-slate-800">{item.city}</h4>
                </div>
                <div className="grid grid-cols-2 gap-2 mb-3">
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-2 border border-blue-100">
                    <div className="flex items-center gap-1 mb-0.5">
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-users h-3 w-3 text-blue-600"
                        >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx={9} cy={7} r={4} />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        <span className="text-xs font-medium text-blue-700">
                        Members
                        </span>
                    </div>
                    <p className="text-sm font-bold text-slate-800">{item.active_member}</p>
                    </div>
                    <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-lg p-2 border border-teal-100">
                    <div className="flex items-center gap-1 mb-0.5">
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-calendar h-3 w-3 text-teal-600"
                        >
                        <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                        <line x1={16} x2={16} y1={2} y2={6} />
                        <line x1={8} x2={8} y1={2} y2={6} />
                        <line x1={3} x2={21} y1={10} y2={10} />
                        </svg>
                        <span className="text-xs font-medium text-teal-700">
                        Meetups
                        </span>
                    </div>
                    <p className="text-sm font-bold text-slate-800">{item.monthly_meetups}</p>
                    </div>
                </div>
                <div className="text-xs text-slate-600 mb-3">Activity: Just now</div>
                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 rounded-md px-3 w-full bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white border-0 text-xs h-8">
                    Join Community
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-chevron-right ml-1 h-3 w-3"
                    >
                    <path d="m9 18 6-6-6-6" />
                    </svg>
                </button>
                </div>
            </div>
            </a>
        ))}

        
        </div>
        <div className="text-center mt-4">
            <a href="/community">
            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 text-xs border-teal-500 text-teal-600 hover:bg-teal-50 bg-transparent">
                Explore All Communities
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-right ml-1 h-3 w-3"
                >
                <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
            </a>
        </div>
    </section>
  );
};

export default MoHomecommunitylist;
